import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { SubscriptionService } from '@core/services/subscription.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionHasFeatureGuard implements CanActivate {
  constructor(
    private subscriptionService: SubscriptionService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const featureName = route.data['featureName']; // Retrieve featureName from route data
    if (this.subscriptionService.subscriptionCanAccess(featureName)) {
      return true; // Allow navigation
    } else {
      this.router.navigate(['/404']);
      return false; // Block navigation
    }
  }
}
